/* --------------------------------------------------
// anime.js
-------------------------------------------------- */
import anime from "animejs/lib/anime.es.js";
window.anime = anime;

/* --------------------------------------------------
// basicScroll.js
-------------------------------------------------- */
import * as basicScroll from "basicscroll/dist/basicScroll.min.js";

/* --------------------------------------------------
// cursor animation
-------------------------------------------------- */
/* 
(function () {
	const cursor = document.querySelector(".cursorhover");
	if (
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		)
	) {
		// true for mobile device
		cursor.remove();
	} else {
		if (!cursor) {
			document.getElementById("pghead").innerHTML +=
				'<span class="cursorhover"><svg class="cursorMov" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet" viewBox="-1 -1 102 102"><circle class="cursor_svg" cx="50" cy="50" r="44"></circle><g><path class="drag_svg" d="M9.9,51.7c-.4-.4-.4-.9,0-1.3l11.1-11.1c.4-.4.9-.4,1.3,0,.4.4.4.9,0,1.3l-10.4,10.4,10.4,10.4c.4.4.4.9,0,1.3-.4.4-.9.4-1.3,0l-11.1-11.1h0Z"></path><path class="drag_svg" d="M92.1,50.3c.4.4.4.9,0,1.3l-11.1,11.1c-.4.4-.9.4-1.3,0-.4-.4-.4-.9,0-1.3l10.4-10.4-10.4-10.4c-.4-.4-.4-.9,0-1.3.4-.4.9-.4,1.3,0l11.1,11.1h0Z"></path></g><path class="enlarge_svg" d="M12.934 8.684a.627.627 0 0 0 0 .882c.242.243.64.243.882 0l6.434-6.433V7.25c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625V1.625A.627.627 0 0 0 20.875 1H15.25a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h4.117l-6.433 6.434Zm-2.868 4.632a.627.627 0 0 0 0-.882.627.627 0 0 0-.882 0L2.75 18.867V14.75a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625v5.625c0 .344.281.625.625.625H7.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625H3.633l6.433-6.434Z"></path></svg></span>';
		}
		const link = document.querySelectorAll(".cursorAni");

		const animateit = function (e) {
			let type = this.dataset.cursor;
			// console.log(this.dataset.cursor);
			if (type !== null) {
				cursor.classList.add(type);
			}

			// cursor.classList.remove("null");

			if (e.type === "mouseleave") cursor.classList.remove(type);
			// if (e.type === "mouseleave") cursor.classList.remove("null");
		};

		const editCursor = (e) => {
			const { clientX: x, clientY: y } = e;
			cursor.style.left = x + "px";
			cursor.style.top = y + "px";
		};
		// false for not mobile device
		link.forEach((b) => b.addEventListener("mouseenter", animateit));
		link.forEach((b) => b.addEventListener("mouseleave", animateit));

		window.addEventListener("mousemove", editCursor);
	}
})();
*/

/* --------------------------------------------------
// scroll append style
-------------------------------------------------- */
let pagebody = document.getElementsByTagName("body")[0];
let pgnav = document.querySelector("#pghead");
let BGsects = document.querySelectorAll(".BGtrans");
let BGsectBs = document.querySelectorAll(".BGtransB");

/* --------------------------------------------------
// stikcy nav class
-------------------------------------------------- */
let curtain = basicScroll.create({
	elem: pagebody,
	from: "0px",
	to: "300px",
	direct: pgnav,
	props: {
		"--bga": {
			from: 0,
			to: 0.7,
		},
	},
	timing: "elasticInOut",
});
curtain.start();

/* --------------------------------------------------
// scroll reveal BG colour
-------------------------------------------------- */
if (BGsects.length > 0) {
	BGsects.forEach((BGsect) => {
		let lighstup = basicScroll.create({
			elem: BGsect,
			from: "top-bottom",
			to: "bottom-bottom",
			direct: BGsect,
			props: {
				"--bga": {
					from: 0,
					to: 1,
				},
			},
			timing: "elasticInOut",
		});
		lighstup.start();
	});
}

if (BGsectBs.length > 0) {
	BGsectBs.forEach((BGsectB) => {
		let lighstupB = basicScroll.create({
			elem: BGsectB,
			from: "top-bottom",
			to: "bottom-bottom",
			direct: BGsectB,
			props: {
				"--bga": {
					from: 0,
					to: 1,
				},
				"--bgab": {
					from: 1,
					to: 0,
				},
			},
			timing: "elasticInOut",
		});
		lighstupB.start();
	});
}

/* --------------------------------------------------
// light follow up
-------------------------------------------------- */
/* 
let feats = document.querySelectorAll(".feat");

if (feats.length > 0) {
	feats.forEach((feat) => {
		feat.addEventListener("mousemove", function (e) {
			let circle = feat.querySelector(".hilgt");
			let left = e.offsetX;
			let top = e.offsetY;
			let cirl = left - 64 + "px";
			let cirt = top - 64 + "px";
			// console.log(left);
			// console.log(top);
			circle.style.setProperty("--cirl", cirl);
			circle.style.setProperty("--cirt", cirt);
		});
	});
}
 */

/* --------------------------------------------------
// IntersectionObserver
-------------------------------------------------- */
if (
	"IntersectionObserver" in window ||
	"IntersectionObserverEntry" in window ||
	"intersectionRatio" in window.IntersectionObserverEntry.prototype
) {
	/* --------------------------------------------------
	// trigger transition
	-------------------------------------------------- */
	let trans = document.querySelectorAll(".trans");

	if (trans.length > 0) {
		// configuration
		let transOptions = {
			root: null,
			rootMargin: "20px 0px 0px 0px",
			// % of the target is visible
			threshold: 0.1,
		};

		var transobserve = new IntersectionObserver(tranlistCallback, transOptions);

		function tranlistCallback(entries, transobserve) {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					let tranel = entry.target;
					let type = entry.target.getAttribute("data-trans");
					let clsname = "trans-" + type;

					tranel.classList.add(clsname);
					transobserve.unobserve(entry.target);
				}
			});
		}

		trans.forEach((tran) => {
			transobserve.observe(tran);
		});
	} // trigger transition

	/* --------------------------------------------------
	// trigger animation
	-------------------------------------------------- */
	let animes = document.querySelectorAll(".animate__animated");

	if (animes.length > 0) {
		// configuration
		let animesOptions = {
			root: null,
			rootMargin: "15px 0px 0px 0px",
			// % of the target is visible
			threshold: 0,
		};

		var animesobserve = new IntersectionObserver(
			animelistCallback,
			animesOptions
		);

		function animelistCallback(entries, animesobserve) {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					let animel = entry.target;
					let type = entry.target.getAttribute("data-ani");

					animel.classList.add(type);
					animesobserve.unobserve(entry.target);
				}
			});
		}

		animes.forEach((anime) => {
			animesobserve.observe(anime);
		});
	} // trigger animation

	/* --------------------------------------------------
	// fade in animation (multi + staggers)
  -------------------------------------------------- */
	let fadestas = document.querySelectorAll(".fadesta");

	if (fadestas.length > 0) {
		// configuration
		let fadestaOptions = {
			root: null,
			rootMargin: "0px 0px 0px 0px",
			// % of the target is visible
			threshold: 0.1,
		};

		var fadestaobserve = new IntersectionObserver(
			fadestaCallback,
			fadestaOptions
		);

		function fadestaCallback(entries, fadestaobserve) {
			entries.forEach((entry) => {
				let fadestaitem = entry.target.children;

				if (entry.intersectionRatio > 0) {
					anime({
						targets: fadestaitem,
						duration: 2400,
						opacity: [0, 1],
						translateY: ["5%", "0"],
						delay: anime.stagger(250),
					});

					// execute only once
					fadestaobserve.unobserve(entry.target);
				}
			});
		}

		fadestas.forEach((fadesta) => {
			fadestaobserve.observe(fadesta);
		});
	} // fade in animation (multi + stagger)

	/* --------------------------------------------------
	// stats
	-------------------------------------------------- */
	let stats = document.querySelectorAll(".stats");

	if (stats.length > 0) {
		// configuration
		let statsOptions = {
			root: null,
			rootMargin: "20px 0px 0px 0px",
			// % of the target is visible
			threshold: 0.1,
		};

		var statsobserve = new IntersectionObserver(tranlistCallback, statsOptions);

		function tranlistCallback(entries, statsobserve) {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					let num = entry.target;
					let tranels = num.querySelectorAll(".statcount");

					tranels.forEach((tranel) => {
						let count = tranel.getAttribute("data-stats");
						anime({
							targets: tranel,
							innerHTML: [0, count],
							round: 1,
							easing: "easeInOutExpo",
							delay: anime.stagger(100),
						});
					});

					statsobserve.unobserve(entry.target);
				}
			});
		}

		stats.forEach((stat) => {
			statsobserve.observe(stat);
		});
	} // stats
} // IntersectionObserver

/* -------------------------------------------------- 
// Parax BG
-------------------------------------------------- */
/* const paras = document.querySelectorAll(".parax");

if (paras.length > 0) {
	paras.forEach((para) => {
		// const start = para.getAttribute("data-start"),
		// 	end = para.getAttribute("data-end");

		basicScroll
			.create({
				elem: para,
				from: "top-top",
				to: "bottom-top",
				direct: true,
				props: {
					"--criterion": {
						from: 0.1,
						to: 0.5,
					},
				},
			})
			.start();
	});
} */

/* --------------------------------------------------
// floating effect
-------------------------------------------------- */
/* let parasects = document.querySelectorAll(".parael");

if (parasects.length > 0) {
	for (let parasect of parasects) {
		let _from = parasect.getAttribute("data-from") || "0px";
		let _to = parasect.getAttribute("data-to") || "100px";

		let float = basicScroll.create({
			elem: parasect,
			from: "top-middle",
			to: "bottom-middle",
			direct: true,
			props: {
				"--ty": {
					from: _from,
					to: _to,
				},
			},
		});
		float.start();
	}
} */

/* --------------------------------------------------
// constant floating
-------------------------------------------------- */
var floatpics = document.querySelectorAll(".flo");

if (floatpics.length > 0) {
	floatpics.forEach((floatpic) => {
		anime({
			targets: floatpic,
			direction: "alternate",
			loop: true,
			translateY: function () {
				return anime.random(-10, 10);
			},
			rotate: function () {
				return anime.random(-5, 15);
			},
			duration: function () {
				return anime.random(1200, 1800);
			},
			delay: function () {
				return anime.random(0, 400);
			},
		});
	});
}

/* -------------------------------------------------- 
// Scroll floating
-------------------------------------------------- */
const floatups = [];

// const anchor = document.querySelector(".sl_anchor");

// Create an animation for each separate elements
const float_tris = document.querySelectorAll(".sf");

if (float_tris.length > 0) {
	float_tris.forEach((float_tri) => {
		// Get the end values from the data attributes
		// const ty = elem.getAttribute("data-ty");

		// Crate an instance for the current element and store the instance in an array.
		// We start the animation later using the instances from the array.
		floatups.push(
			basicScroll.create({
				elem: float_tri,
				from: "top-bottom",
				to: "bottom-top",
				direct: true,
				props: {
					"--criterion": {
						from: 1,
						to: 0,
					},
				},
			})
		);
	});
}

floatups.forEach((floatup) => floatup.start());
